import { MediaSectionElement } from "./MediaSectionElement";

export default MediaSectionElement;
